export const KUCOIN_POST_GET_TRADE_URL = "https://api.kucoin.com/api/v1/orders";
export const MEXC_POST_GET_TRADE_URL = "https://api.mexc.com/api/v3/order";
export const GATEIO_POST_GET_TRADE_URL = "https://api.gateio.ws/api/v4/spot/orders";
export const BYBIT_POST_TRADE_URL = "https://api.bybit.com/v5/order/create";
export const BYBIT_GET_TRADE_URL = "https://api.bybit.com/v5/order/history";
export const BYBIT_GET_OPEN_ORDERS_URL = "https://api.bybit.com/v5/order/realtime";
export const BITGET_POST_TRADE_URL = "https://api.bitget.com/api/v2/spot/trade/place-order";
export const BITGET_GET_TRADE_URL = "https://api.bitget.com/api/v2/spot/trade/orderInfo";
export const BINANCE_POST_TRADE_URL = "https://api.binance.com/api/v3/order";
export const BYBIT_GET_USER_URL = "https://api.bybit.com/v5/user/query-api";
